import { createSubscription } from 'components/Pages/Settings/actions.js';

export const createBulkSubscriptions = newSubscriptions => (dispatch) => {
  newSubscriptions.map(subscription => dispatch(createSubscription(subscription)));
};
